import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SETTINGS } from '../config/common.settings';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AgentService {
  constructor(private http: HttpClient) {}

  createAgent(payload: any): Observable<any> {
    return this.http.post(`${SETTINGS.BASE_API}/agent/create`, payload);
  }

  getPagedAgents(payload: any): Observable<any> {
    return this.http.post(`${SETTINGS.BASE_API}/agent/get-paged`, payload);
  }

  updateAgent(payload: any): Observable<any> {
    return this.http.put(`${SETTINGS.BASE_API}/agent/update`, payload);
  }

  deleteAgent(id: any): Observable<any> {
    return this.http.delete(`${SETTINGS.BASE_API}/agent/soft-delete/${id}`);
  }

  getAgentById(id: any): Observable<any> {
    return this.http.get(`${SETTINGS.BASE_API}/agent/${id}`);
  }

  getAllActiveAgents(payload?: any): Observable<any> {
    return this.http.post(`${SETTINGS.BASE_API}/agent/get-all-active`, payload);
  }

  getAllTransferAgents(): Observable<any> {
    return this.http.post(`${SETTINGS.BASE_API}/agent/get-all-transfer`, {});
  }

  getPagedAgentsTempBookings(payload: any): Observable<any> {
    return this.http.post(
      `${SETTINGS.BASE_API}/agent/temp-bookings/get-paged`,
      payload,
    );
  }

  getAgentTempBookingById(id: any): Observable<any> {
    return this.http.get(`${SETTINGS.BASE_API}/agent/temp-bookings/${id}`);
  }

  updateAgentTempBooking(payload: any): Observable<any> {
    return this.http.put(
      `${SETTINGS.BASE_API}/agent/temp-bookings/update`,
      payload,
    );
  }
}
